import api from "./axiosInstance";

export interface SearchResultDto {
  parts: SearchResult[] | null;
  searchType: 'Database' | 'Global';
  message: string;
  hasGlobalSearchOption: boolean;
}

export interface SearchResult {
  id: number;
  uniqueId: string;
  name: string;
  description: string;
  code: string;
  originalСode: string;
  brandName: string;
  brandOriginalName: string;
  brandId: number;
  providerInfo: string;
  imageUpdated: boolean;
  contentId: string | null;
  content: string | null;
  shateLastSearch: string | null;
  rosskoLastSearch: string | null;
  autopiterLastSearch: string | null;
}

export const SearchAPI = {
  async getProducts(value: string) {
    const response = await api.get(`/parts/search?searchValue=${value}`);
    return response.data;
  },

  async getProductsWithType(value: string): Promise<SearchResultDto> {
    const response = await api.get(`/parts/search/with-type?searchValue=${value}`);
    return response.data;
  },

  async getProductsGlobal(value: string) {
    const response = await api.get(`/parts/search/global?searchValue=${value}`);
    return response.data;
  },

  async getProductsDatabase(value: string) {
    const response = await api.get(`/parts/search/database?searchValue=${value}`);
    return response.data;
  },

  async getProductsRossko(value: string) {
    const response = await api.get(`/parts/search/rossko?searchValue=${value}`);
    return response.data;
  },

  async getMultiSearchResults(terms: string[]) {
    const response = await api.post(`/parts/search/multi`, { terms });
    return response.data;
  }
};